"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ThirdPartyInterstitialContent = exports.ThirdPartyInterstitial = void 0;
var _styledComponentThemes = require("../../_nextgen/packages/styled-component-themes");
var _CTAList = _interopRequireDefault(require("../../components/CTAList"));
var _Text = _interopRequireDefault(require("../../components/Text"));
var _analytics = require("../../components/analytics");
var _breakpoints = require("../../components/breakpoints");
var _Overlay = _interopRequireWildcard(require("../Overlay"));
var Styled = _interopRequireWildcard(require("./index.styled"));
var _jsxRuntime = require("react/jsx-runtime");
const ThirdPartyInterstitialContent = function (_ref) {
  let {
    header,
    body,
    ctas,
    className
  } = _ref;
  const {
    href,
    target = "_self"
  } = (0, _Overlay.useOverlayContextData)();
  const urlObject = new URL(href !== null && href !== void 0 ? href : "", window.location.origin);
  const [, close] = (0, _Overlay.useOverlay)({
    id: "third-party-interstitial"
  });
  const updateCtas = function (ctas) {
    return ctas.map(function (cta) {
      if (cta.href === "{exit}") {
        return {
          ...cta,
          href: undefined,
          isExternal: false,
          onClick: function (e) {
            e.preventDefault();
            close();
          }
        };
      }
      if (cta.href === "{url}") {
        return {
          ...cta,
          href: href,
          target,
          isExternal: false,
          onClick: function () {
            close();
          }
        };
      }
      return cta;
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.ThirdPartyWrapper, {
    className: className,
    "data-testid": "ThirdPartyInterstitialContent",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.ThirdPartyCopy, {
      children: [header && /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Heading, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          children: header
        })
      }), body && /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Body, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          bindings: {
            host: urlObject.host,
            hostname: urlObject.hostname,
            href: urlObject.href,
            origin: urlObject.origin,
            target: target,
            onClick: function () {
              close();
            }
          },
          children: body
        })
      })]
    }), ctas && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CTAList.default, {
      ctas: updateCtas(ctas),
      alignCtas: "center"
    })]
  });
};
exports.ThirdPartyInterstitialContent = ThirdPartyInterstitialContent;
const ThirdPartyInterstitial = function (props) {
  const isMobile = (0, _breakpoints.useMobileBreakpoint)();
  const overlayProps = {
    id: "third-party-interstitial",
    pageSpacing: false,
    lightbox: false,
    background: "#FFF",
    display: "block",
    width: "auto",
    height: isMobile ? "100%" : "auto",
    hideClose: true,
    src: undefined,
    closeOutside: false
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styledComponentThemes.ThemeProvider, {
    theme: "white",
    "data-testid": "ThirdPartyInterstitial",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Overlay.default, {
      ...overlayProps,
      fit: "lightbox",
      pageSpacing: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ThirdPartyInterstitialContent, {
        ...props
      })
    })
  });
};
exports.ThirdPartyInterstitial = ThirdPartyInterstitial;
var _default = exports.default = (0, _analytics.withAnalytics)(ThirdPartyInterstitial)({});